var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfiguration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.096,
    height: 40,
    viewBox: "0 0 53.096 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(-530 -384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(530 384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_430115_configuration_settings_icon",
    "data-name": "430115_configuration_settings_icon",
    transform: "translate(12.527 9.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M27.278,63.154H14.734a.549.549,0,1,1,0-1.1H27.278a.549.549,0,0,1,0,1.1Z",
    transform: "translate(-14.185 -51.585)",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M92.859,63.154H86.2a.549.549,0,0,1,0-1.1h6.655a.549.549,0,0,1,0,1.1Z",
    transform: "translate(-66.043 -51.585)",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M23.6,93.707H14.734a.549.549,0,1,1,0-1.1H23.6a.549.549,0,0,1,0,1.1Z",
    transform: "translate(-14.185 -73.753)",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M83.508,93.707H73.323a.549.549,0,1,1,0-1.1H83.508a.549.549,0,0,1,0,1.1Z",
    transform: "translate(-56.697 -73.753)",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M19.9,32.6H14.734a.549.549,0,0,1,0-1.1H19.9a.549.549,0,0,1,0,1.1Z",
    transform: "translate(-14.185 -29.415)",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M73.356,32.6H59.325a.549.549,0,0,1,0-1.1H73.356a.549.549,0,1,1,0,1.1Z",
    transform: "translate(-46.54 -29.415)",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M35.647,29.167a2.635,2.635,0,1,1,2.635-2.635,2.635,2.635,0,0,1-2.635,2.635Zm0-4.173a1.537,1.537,0,1,0,1.537,1.537,1.537,1.537,0,0,0-1.537-1.537Z",
    transform: "translate(-27.845 -23.897)",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M49.137,90.277a2.635,2.635,0,1,1,2.636-2.636,2.635,2.635,0,0,1-2.636,2.636Zm0-4.174a1.538,1.538,0,1,0,1.539,1.537A1.538,1.538,0,0,0,49.137,86.1Z",
    transform: "translate(-37.634 -68.236)",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M62.53,59.723a2.635,2.635,0,1,1,2.635-2.636A2.635,2.635,0,0,1,62.53,59.723Zm0-4.174a1.539,1.539,0,1,0,1.537,1.537A1.539,1.539,0,0,0,62.53,55.55Z",
    transform: "translate(-47.35 -46.067)",
    stroke: "#fff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "box-fragile-svgrepo-com",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M50.491,51.307H2.6A2.536,2.536,0,0,0,0,53.761V88.853a2.536,2.536,0,0,0,2.6,2.454H50.491a2.536,2.536,0,0,0,2.6-2.454V53.761A2.536,2.536,0,0,0,50.491,51.307Zm.942,37.546a.917.917,0,0,1-.942.888H2.6a.917.917,0,0,1-.942-.888V53.761a.917.917,0,0,1,.942-.888H50.491a.917.917,0,0,1,.942.888V88.853Z",
    transform: "translate(0 -51.307)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguration);
export default __webpack_public_path__ + "static/media/configuration.02361854c571213820fedb8106941abe.svg";
export { ForwardRef as ReactComponent };